import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Container from '../components/Container';
import SectionTitle from '../components/SectionTitle';
import PortfolioGridOptimized from '../components/PortfolioGridOptimized';
import ComponentErrorBoundary from '../components/ComponentErrorBoundary';
import Button from '../components/Button';

// Import content
import portfolioContent from '../content/portfolio.json';

/**
 * Portfolio page component
 * @returns {React.ReactElement} Portfolio page
 */
const PortfolioPage = () => {
  // Get portfolio items from JSON file
  const { items: portfolioItems } = portfolioContent;

  return (
    <div className="min-h-screen flex flex-col bg-brand-black text-white">
      <Header />
      
      {/* Page Header */}
      <section className="pt-40 md:pt-48 lg:pt-56 pb-12 bg-brand-black text-white">
        <Container>
          <SectionTitle 
            title="Our Portfolio" 
            subtitle="Explore our recent aerial photography and videography projects"
            className="mb-0"
          />
        </Container>
      </section>

      {/* Portfolio Section */}
      <section className="py-16 md:py-24 bg-brand-black">
        <Container>
          <ComponentErrorBoundary 
            fallbackMessage="Portfolio images are temporarily unavailable. Please refresh the page or contact us to view our work."
            componentName="PortfolioGrid"
            showRetry={true}
          >
            <PortfolioGridOptimized items={portfolioItems} />
          </ComponentErrorBoundary>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-brand-black text-white">
        <Container>
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4">Ready to Start Your Project?</h2>
            <p className="text-lg mb-8">
              Contact us today to discuss your aerial photography and videography needs.
            </p>
            <Button href="/contact">Get a Free Quote</Button>
          </div>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default PortfolioPage;
